export default __webpack_public_path__ + "static/media/inr-rs-1.310983e3.png";